import { render, staticRenderFns } from "./WebIcon.vue?vue&type=template&id=13aadbd2&"
import script from "./WebIcon.vue?vue&type=script&lang=js&"
export * from "./WebIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports